class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open on hover for devices with a mouse. Touch devices keep tap-to-open.
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.closeTimer = null;
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimer);

    // Close any other header menu that is still open
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.hasAttribute('open')) menu.close();
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!this.hoverQuery.matches) return;
    // Short delay so the menu doesn't flicker shut while the cursor crosses the gap
    this.closeTimer = setTimeout(() => this.close(), 150);
  }

  onSummaryClick(event) {
    // With hover, a mouse click would immediately close the menu it just opened.
    // event.detail is 0 for keyboard activation, so keyboard users can still toggle.
    if (this.hoverQuery.matches && event.detail > 0) event.preventDefault();
  }
  close() {
    super.close();

    // Reset any sub-menus (Style, Theme, Emotion, Room, Color) so they
    // are closed the next time the parent menu is opened.
    this.mainDetailsToggle.querySelectorAll('details[open]').forEach((subDetails) => {
      subDetails.removeAttribute('open');
      const subSummary = subDetails.querySelector('summary');
      if (subSummary) subSummary.setAttribute('aria-expanded', false);
    });
  }
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
customElements.define('header-menu', HeaderMenu);
